import TrackDataHelper from '../helpers/track-data-helper';
import AnalyticsHelper from '../helpers/analytics';
import AnalyticsTrack from './analytics-track';

export default {
    methods: {
        rateTableViewedInfo(offersResult) {
            let trackObj;
            let resultCount;
            let loanTerm;
            let offerProductType;
            let sortByFilter = '';
            if (offersResult.TrackOfferResult && offersResult.TrackOfferResult.length > 0) {
                const offer = offersResult.TrackOfferResult[0];
                resultCount = offersResult.TrackOfferResult.length;
                loanTerm = offer.loanProgram || '';
                offerProductType = offer.productCategory || offersResult.calcParent;

                // For Auto Loans product type
                if (offer.VehicleLoanClassDescription) {
                    offerProductType = 'Auto '.concat(offer.VehicleLoanClassDescription);
                    loanTerm = offer.AmortizationTermMonths.toString().concat(' Months');
                }
                if (offer.VehicleClassDescription) { // Incase of Auto Purchase product
                    sortByFilter = offer.VehicleClassDescription;
                }
            } else { // if no offers to show
                offerProductType = offersResult.loanType || offersResult.calcParent;
                if (offersResult.autoLoanType) {
                    offerProductType = 'Auto '.concat(offersResult.autoLoanType);
                    sortByFilter = offersResult.selectedTab || '';
                }
            }
            // For Personal Loans product type
            if (offersResult.ShowLowestAPR !== undefined) {
                sortByFilter = 'Lowest Loan Payment';
                if (offersResult.ShowLowestAPR) {
                    sortByFilter = 'Lowest APR';
                }
            }
            trackObj = {
                resultCount: resultCount || 'None',
                loanTerm: loanTerm || 'None',
                fieldEdited: offersResult.fieldEdited || 'no',
                productType: offerProductType || '',
                sortBy: sortByFilter,
            };
            if (Object.keys(trackObj).length > 0) {
                this.fireTrackCall('RateTableViewed', trackObj);
            }
        },
        rateTableClickedInfo(offerInfo) {
            let trackObj;
            let offerlenderName;
            let offerLoanTerm;
            offerLoanTerm = offerInfo.LoanProgram || '';
            if (offerInfo.ClickLocation) {
                const lenderName = offerInfo.LenderName || offerInfo.Offer.lenderName;
                offerlenderName = offerInfo.ClickLocation.concat(lenderName);
            } else {
                offerlenderName = 'ButtonClicked/'.concat(offerInfo.offer.PartnerName);
            }
            if (offerInfo.offer && offerInfo.offer.AmortizationTermMonths) { // for auto product type
                offerLoanTerm = offerInfo.offer.AmortizationTermMonths.toString().concat(' Months');
            } else if (offerInfo.Offer && offerInfo.Offer.loanLength) { // for personal loans
                offerLoanTerm = offerInfo.Offer.loanLength.toString().concat(' Months');
            }

            trackObj = {
                lenderName: offerlenderName || '',
                position: offerInfo.Position || offerInfo.offer.Position,
                loanTerm: offerLoanTerm || '',
                fieldEdited: offerInfo.FieldEdited || 'no',
                productType: offerInfo.LoanType || 'Auto '.concat(offerInfo.offer.VehicleLoanClassDescription),
            };
            // Sort By fileter in Personal Loans product type
            if (offerInfo.showLowestApr !== undefined) {
                let sortByFilter = 'Lowest Loan Payment';
                if (offerInfo.ShowLowestAPR) {
                    sortByFilter = 'Lowest APR';
                }
                trackObj.sortBy = sortByFilter;
            }

            if (offerInfo.offer.VehicleClassDescription) { // For Auto Purchase product
                trackObj.sortBy = offerInfo.offer.VehicleClassDescription;
            }

            if (Object.keys(trackObj).length > 0) {
                this.fireTrackCall('RateTableOffersClicked', trackObj);
            }
        },
        fireTrackCall(type, trackObj) {
            const eventName = {
                RateTableViewed: 'RateTable Viewed',
                RateTableOffersClicked: 'RateTable Offers Clicked',
            }[type];
            if (type === 'RateTableViewed') {
                TrackDataHelper.setMany(
                    this.trackRateTableViewed(trackObj),
                    type,
                );
            } else {
                TrackDataHelper.setMany(
                    this.trackRateTableClicked(trackObj),
                    type,
                );
            }
            AnalyticsHelper.track(
                eventName,
                TrackDataHelper.get(type),
            );
        },
    },
    mixins: [AnalyticsTrack],
};
